import React, { useEffect, useState } from "react";
import { configs, formatCurrency, formatNumber } from "../../../assets/Config";
import "../../../assets/styles/BuyOrder.css"

import { useBuyOrderContext } from "../../../services/contexts/BuyOrdersContext";
import { DataGrid } from "@material-ui/data-grid";
import { Link } from "@material-ui/core";
import { useLogin } from "../../../services/contexts/AdminLoginContext";
import { useKYCContext } from "../../../services/contexts/KYCContext";

export default function OrderUpdateHistory() {

    const { orderHistory, setOrderHistory, orderDetail, setOrderDetail } = useBuyOrderContext();
    const { setKycRequesterUserDetail } = useKYCContext();
    const { allowedFunc } = useLogin();

    const columns = [
        { field: "id", headerName: "Id", minWidth: 100, flex: 0.1, hide: true, cellClassName: "break-text f-12" },
        {
            field: "name", headerName: "Name", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", valueGetter: (params) => {
                return params.row.user.name
            }
        },
        {
            field: "mobile", headerName: "Phone No.", minWidth: 100, flex: 0.3, cellClassName: "break-text f-12", renderCell: (params) => {
                return <a href={"https://wa.me/" + params.row.user.mobile} target="_blank">{params.row.user.mobile ? `+${params.row.user.mobile}` : params.row.user.mobile}</a>
            }, valueGetter: (value) => value.row.user.mobile ? `+${value.row.user.mobile}` : value.row.user.mobile
        },
        {
            field: "email", headerName: "E-mail", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                if (allowedFunc.includes(configs.functionList['user_management:load_user_details'])) {
                    return <Link to={`/customerProfile/${params.row.user.id}`} onClick={() => {
                        setKycRequesterUserDetail(params.row.user)
                    }}>{params.row.user.email}</Link>
                } else {
                    return params.row.user.email
                }
            }, valueGetter: (value) => value.row.user.email
        }, {
            field: "quantity", headerName: "Quantity", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", valueGetter: (params) => {
                return formatNumber(parseInt(params.row.quantity))
            }
        }, {
            field: "preice/share", headerName: "Price/Share", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", valueGetter: (params) => {
                return formatCurrency(parseFloat(params.row.price / params.row.quantity))
            }
        }, {
            field: "price", headerName: "Price", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.price))
            }, valueGetter: (value) => value.row.price
        }, {
            field: "upmark", headerName: "Upmark", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.upmark))
            }, valueGetter: (value) => value.row.upmark
        },
        {
            field: "upmark_final_pay", headerName: "Upmark Final Pay", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.upmark_final_pay))
            }, valueGetter: (value) => value.row.upmark_final_pay
        },
        { field: "message", headerName: "Remark", minWidth: 250, flex: 0.4, cellClassName: "break-text text-capitalize f-12" },
        {
            field: "modifiedBy", headerName: "Modified By", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return params.row.admin.name
            }, valueGetter: (value) => value.row.admin.name
        },
        {
            field: "timestamp", headerName: "Timestamp", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", valueGetter: (params) => {
                return params.row.timestamp
            }
        },

    ]

    return (
        <div id='buyOrderContainer' className="smbo-container">
            <div style={{ width: "100%" }}>
                <div className="row mx-md-4 mx-2 my-2 p-0">
                    <div className="col-md-12 m-0 p-0">
                        <div className='row m-0 mb-2 p-0'>
                            <div className='col-12 p-0 d-flex justify-content-between'>
                                <p className="h5 text-custom-grey"><span className="mr-3" onClick={(e) => {
                                    setOrderHistory(false);
                                    setOrderDetail("")
                                }}><i className="far fa-arrow-alt-circle-left curPoint text-primary"></i></span>Order History - {orderDetail.order_id}</p>
                                <p className="h5 text-custom-grey">{orderDetail.company_name}</p>

                            </div>

                        </div>
                    </div>
                </div>
                <div className="kyc-table">
                    {orderDetail ? <DataGrid
                        rows={orderDetail.order_update_history}
                        columns={columns}
                        resizable={true}
                        autoPageSize={true}
                        pagination
                        headerHeight={30}
                        rowHeight={40}

                    />
                        : <div className="loader"></div>}
                </div>
            </div>
        </div>
    )
}